import React, { SVGProps } from 'react';

/**
 * viewBox='0 0 24 24' er den faktiske størrelsen på svg'en. De to siste veridene må være svgen sin
 * faktiske bredde og høyde. Hvis ikke vil svg'en bli strukket til å fylle hele plassen den har.
 * widt og height er satt til 100% for å fylle hele plassen den har.
 * @param props
 * @constructor
 */
interface SvgProps extends SVGProps<SVGSVGElement> {
	pathFill?: string;
	color?: string;
}

export const Delete: React.FC<SvgProps> = ({ pathFill = '#697277', ...props }) => {
	return (
		<svg
			width='16'
			height='16'
			viewBox='0 0 16 16'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			{...props}
		>
			<g id='Ikon'>
				<path
					id='Vector'
					d='M6.32812 1.6125L5.73438 2.5H10.2656L9.67188 1.6125C9.625 1.54375 9.54688 1.5 9.4625 1.5H6.53438C6.45 1.5 6.37187 1.54062 6.325 1.6125H6.32812ZM10.9219 0.78125L12.0688 2.5H12.5H14H14.25C14.6656 2.5 15 2.83437 15 3.25C15 3.66563 14.6656 4 14.25 4H14V13.5C14 14.8813 12.8813 16 11.5 16H4.5C3.11875 16 2 14.8813 2 13.5V4H1.75C1.33437 4 1 3.66563 1 3.25C1 2.83437 1.33437 2.5 1.75 2.5H2H3.5H3.93125L5.07812 0.778125C5.40312 0.29375 5.95 0 6.53438 0H9.4625C10.0469 0 10.5938 0.29375 10.9187 0.778125L10.9219 0.78125ZM3.5 4V13.5C3.5 14.0531 3.94688 14.5 4.5 14.5H11.5C12.0531 14.5 12.5 14.0531 12.5 13.5V4H3.5ZM6 6V12.5C6 12.775 5.775 13 5.5 13C5.225 13 5 12.775 5 12.5V6C5 5.725 5.225 5.5 5.5 5.5C5.775 5.5 6 5.725 6 6ZM8.5 6V12.5C8.5 12.775 8.275 13 8 13C7.725 13 7.5 12.775 7.5 12.5V6C7.5 5.725 7.725 5.5 8 5.5C8.275 5.5 8.5 5.725 8.5 6ZM11 6V12.5C11 12.775 10.775 13 10.5 13C10.225 13 10 12.775 10 12.5V6C10 5.725 10.225 5.5 10.5 5.5C10.775 5.5 11 5.725 11 6Z'
					fill={pathFill}
				/>
			</g>
		</svg>
	);
};
